/*
 * @Author: Jhony Reyes 
 * @Date: 2018-04-12 00:04:27 
 * @Last Modified by: Alejandro Leonor
 * @Last Modified time: 2018-04-13 19:15:26
 */
const CONTAINER_KEY = 'LOGIN_CONTAINER';
export const LOGIN_USER = `${CONTAINER_KEY}_LOGIN_USER`;
export const LOGIN_USER_SUCCESSFUL = `${CONTAINER_KEY}_LOGIN_USER_SUCCESSFUL`;
